import { defaultInput100, defaultInput50, defaultSelect100 } from "../../../../components-variants/defaultInputs";
import { StyledCreateAutomaticMsgRoutinePage } from "./style";
import { useEffect, useState } from "react";
import api from "../../../../services/api";
import { UserData } from "../../../../interfaces/Users.interfaces";
import { CustomState } from "../../../../Hooks/State.hook";
import cssVars from "../../../../styles/cssVariables.vars";
import { toast } from "react-toastify";
import Select from "../../../../components/Select";
import Input from "../../../../components/Input";
import { OperatorAutomaticMsg } from "../../../../interfaces/OperatorAutomaticMsg.interface";
import EmojiPicker from "emoji-picker-react";
import { FaSmile } from "react-icons/fa";
import { FaPaperclip, FaRegFile, FaRegFilePdf, FaSpinner, FaX } from "react-icons/fa6";

export const CreateAutomaticMsgRoutine = () => {
	const operatorToExport = CustomState<number | null>(null);
	const operators = CustomState<UserData[]>([]);
	const showEmojiPicker = CustomState<boolean>(false);

	const createNewRoutine = CustomState<boolean>(false);
	const newOperatorRoutine = CustomState<Partial<OperatorAutomaticMsg> | null>(null);

	const operatorRoutineMsg = CustomState<string | null | undefined>(null);
	const files = CustomState<File[] | null>(null);
	const ChosenOperatorRoutines = CustomState<OperatorAutomaticMsg[] | null>(null);

	const editRoutine = CustomState<boolean>(false);
	const editedOperatorRoutine = CustomState<Partial<OperatorAutomaticMsg> | null>(null);

	useEffect(() => {
		api.get<UserData[]>(`/operators`).then((res) => {
			operators.set(res.data.filter((o) => o.CODIGO > 0 && o.ATIVO === "SIM"));
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		newOperatorRoutine.reset();
		showEmojiPicker.reset();
		files.reset();

		if (createNewRoutine.value) {
			editedOperatorRoutine.reset();
			operatorRoutineMsg.reset();
		}
		if (editRoutine.value) {
			files.set(
				editedOperatorRoutine.value?.files?.map((file) => {
					const uint8Array = new Uint8Array(file.buffer.data);

					const blob = new Blob([uint8Array], { type: file.fileType });

					const finalFile = new File([blob], file.originalFileName, { type: file.fileType });

					return finalFile;
				}) || null
			);
		}
	}, [createNewRoutine.value, editRoutine.value]);

	useEffect(() => {
		operatorRoutineMsg.reset();
		files.reset();
		editedOperatorRoutine.reset();
		newOperatorRoutine.reset();
		editRoutine.reset();
		createNewRoutine.reset();
		showEmojiPicker.reset();

		if (operatorToExport.value) {
			getOperatorRoutinesFn();
		}
	}, [operatorToExport.value]);

	async function getOperatorRoutinesFn() {
		await api
			.get<OperatorAutomaticMsg[]>(`operators/automaticMessagesRoutine/${operatorToExport.value}`)
			.then((res) => {
				ChosenOperatorRoutines.set(
					res.data.map((routine) => ({
						...routine,
						files: routine.files?.map((file) => ({
							fileId: file.fileId,
							fileType: file.fileType,
							fileName: file.fileName,
							originalFileName: file.originalFileName,
							buffer: file.buffer,
						})),
					}))
				);
			});
	}

	function createNewRoutineFn() {
		if (
			newOperatorRoutine.value &&
			newOperatorRoutine.value.startTime &&
			newOperatorRoutine.value.endTime &&
			operatorRoutineMsg.value &&
			createNewRoutine.value
		) {
			const formData = new FormData();
			formData.append("timeRange", `${newOperatorRoutine.value.startTime}-${newOperatorRoutine.value.endTime}`);
			formData.append("message", encodeURI(operatorRoutineMsg.value));
			files.value?.forEach((file) => {
				formData.append("file", file);
			});
			api
				.post(`/operators/automaticMessagesRoutine/${operatorToExport.value}`, formData)
				.then(() => {
					toast.success("Rotina criada com sucesso");
					operatorToExport.reset();
				})
				.catch((err) => {
					console.log(err);
					toast.error("Erro ao criar rotina");
				});
		} else {
			toast.error("Preencha todos os campos corretamente");
		}
	}

	function updateRoutineFn() {
		if (
			editedOperatorRoutine.value &&
			editedOperatorRoutine.value.startTime &&
			editedOperatorRoutine.value.endTime &&
			operatorRoutineMsg.value &&
			editRoutine.value
		) {
			const formData = new FormData();
			formData.append("timeRange", `${editedOperatorRoutine.value.startTime}-${editedOperatorRoutine.value.endTime}`);
			formData.append("message", encodeURI(operatorRoutineMsg.value));
			files.value?.forEach((file) => {
				formData.append("file", file);
			});
			api
				.patch(`/operators/automaticMessagesRoutine/${editedOperatorRoutine.value.routineId}`, formData)
				.then(() => {
					toast.success("Rotina atualizada com sucesso");
					operatorToExport.reset();
				})
				.catch((err) => {
					console.log(err);
					toast.error("Erro ao atualizar rotina");
				});
		} else {
			toast.error("Preencha todos os campos corretamente");
		}
	}

	function deleteRoutineFn() {
		if (editedOperatorRoutine.value && editedOperatorRoutine.value.routineId) {
			api
				.delete(`/operators/automaticMessagesRoutine/${editedOperatorRoutine.value.routineId}`)
				.then(() => {
					toast.success("Rotina excluída com sucesso");
					operatorToExport.reset();
					ChosenOperatorRoutines.set((prev) => {
						if (prev) {
							return prev.filter((o) => o.routineId !== editedOperatorRoutine.value?.routineId);
						}
						return prev;
					});
				})
				.catch((err) => {
					console.log(err);
					toast.error("Erro ao excluir rotina");
				});
		} else {
			toast.error("Erro ao excluir rotina");
		}
	}

	const operatorOptions = [
		{ name: "Carteira compartilhada", value: -1, key: -255 },
		...operators.value.map((o) => {
			return { name: o.NOME, value: o.CODIGO, key: o.CODIGO };
		}),
	];
	const operatorRoutineOptions = [
		{ name: "Criar nova rotina", value: 48487465482487648, key: 48487465482487648 },
		...(ChosenOperatorRoutines.value?.map((o) => {
			return { name: `${o.startTime?.slice(0, 5) || ""} - ${o.endTime?.slice(0, 5) || ""}`, value: o.routineId, key: o.routineId };
		}) || [{ name: "Criar nova rotina", value: 48487465482487648, key: 48487465482487648 }]),
	];

	const disabled = !operatorToExport.value;
	const showOperatorInputs = operatorToExport.value ? true : false;
	const showEditRoutineInputs = editRoutine.value ? true : false;
	const showNewRoutineInputs = createNewRoutine.value ? true : false;

	return (
		<StyledCreateAutomaticMsgRoutinePage>
			<div className="select-options">
				<div style={{ display: "flex", gap: "1rem" }}>
					<Select
						{...defaultSelect100}
						$fontSize={1}
						$padding={[0.5, 0.5]}
						$focusColor={cssVars.colorGrey[2]}
						$color={cssVars.colorGrey[3]}
						options={operatorOptions}
						onChange={(e) => operatorToExport.set(e)}
						placeholder="Selecione o atendente"
					/>
				</div>

				{showOperatorInputs === true && (
					<>
						<div style={{ display: "flex", gap: "1rem" }}>
							<Select
								{...defaultSelect100}
								$fontSize={1}
								$padding={[0.5, 0.5]}
								$focusColor={cssVars.colorGrey[2]}
								$color={cssVars.colorGrey[3]}
								options={operatorRoutineOptions}
								onChange={(e) => {
									if (e === 48487465482487648) {
										createNewRoutine.set(true);
										editRoutine.reset();
										editedOperatorRoutine.reset();
									} else if (typeof e === "number") {
										createNewRoutine.reset();
										editRoutine.set(true);
										editedOperatorRoutine.set(ChosenOperatorRoutines.value?.find((o) => o.routineId === e) || null);
										operatorRoutineMsg.set(
											decodeURI(ChosenOperatorRoutines.value?.find((o) => o.routineId === e)?.message || "")
										);
									}
								}}
								placeholder="Selecione a mensagem automatica do operador"
							/>
						</div>

						{showEditRoutineInputs === true && (
							<>
								<div style={{ display: "inline-block", gap: "1rem" }} className="time-select">
									<div style={{ display: "flex", gap: "1rem", flexDirection: "column" }}>
										<div style={{ display: "flex", gap: "1rem", width: "100%" }}>
											<div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
												<label>Horário de início</label>
												<Input
													{...defaultSelect100}
													type="time"
													value={editedOperatorRoutine.value?.startTime || ""}
													onChange={(e) => {
														editedOperatorRoutine.set((prev) => ({
															...prev,
															startTime: e ? e.target.value.toString() : undefined,
														}));
													}}
												/>
											</div>
											<div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
												<label>Horário de fim</label>
												<Input
													{...defaultSelect100}
													type="time"
													value={editedOperatorRoutine.value?.endTime || ""}
													onChange={(e) => {
														editedOperatorRoutine.set((prev) => ({
															...prev,
															endTime: e ? e.target.value.toString() : undefined,
														}));
													}}
												/>
											</div>
										</div>
									</div>
								</div>
								<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
									{showEmojiPicker.value && (
										<div
											style={{
												display: "flex",
												marginTop: `${window.innerHeight < 800 ? "0.8rem" : window.innerWidth > 1920 ? "3.5rem" : "4.5rem"
													}`,
												gap: "1rem",
												alignSelf: "center",
												maxHeight: "30rem",
												maxWidth: "100%",
												position: "absolute",
												zIndex: 9999,
												left: "6.2rem",
											}}
										>
											<EmojiPicker
												width="30rem"
												height={window.innerHeight < 800 ? "17rem" : window.innerWidth > 1920 ? "23rem" : "30rem"}
												previewConfig={{
													showPreview: false,
												}}
												onEmojiClick={(e) => operatorRoutineMsg.set((prev) => (prev ? prev + e.emoji : "" + e.emoji))}
											/>
										</div>
									)}

									<div
										style={{
											gap: "0",
											marginTop: `${window.innerHeight < 800 ? "18rem" : window.innerWidth > 1920 ? "27rem" : "35rem"}`,
										}}
									>
										<Input
											{...defaultInput100}
											$fontSize={0}
											$width="0px"
											$disableBorder
											style={{ display: "none" }}
											id="fileInput"
											type="file"
											accept="image/*,video/*,.pdf,.txt,.csv,.xlsx,.doc,.docx"
											onChange={(e) => {
												const uploadedFiles = e.target.files;
												if (uploadedFiles) {
													let totalSize = 0;
													let filesToAdd: File[] = [];
													for (let i = 0; i < uploadedFiles.length; i++) {
														totalSize += uploadedFiles[i].size;
														if (uploadedFiles[i].size > 50 * 1024 * 1024) {
															toast.error(`Arquivo ${uploadedFiles[i].name} é acima de 50MB.`);
															return;
														}
														if (totalSize > 50 * 1024 * 1024) {
															toast.error("O tamanho total dos arquivos é acima de 50MB.");
															return;
														}
														if (filesToAdd.length > 1) {
															toast.error("Limite de 1 arquivos.");
															files.set(filesToAdd);
															return;
														}
														filesToAdd.push(uploadedFiles[i]);
													}
													if (totalSize > 50 * 1024 * 1024) {
														return;
													}
													files.set(filesToAdd);
												}
											}}
										/>
										<div
											style={{
												display: "flex",
												gap: "2rem",
												alignItems: "center",
												maxHeight: "0rem",
												maxWidth: "100%",
											}}
										>
											{files.value &&
												files.value.length > 0 &&
												files.value.map((file, index) => {
													return (
														<div
															key={index}
															style={{
																padding: "0.5rem",
																display: "flex",
																flexDirection: "column",
																alignItems: "center",
																justifyContent: "center",
																gap: "0.5rem",
																marginBottom:
																	window.innerHeight < 800 ? "17rem" : window.innerWidth > 1920 ? "20rem" : "21rem",
																maxHeight:
																	window.innerHeight < 800 ? "15rem" : window.innerWidth > 1920 ? "18rem" : "18rem",
																maxWidth:
																	window.innerHeight < 800 ? "15rem" : window.innerWidth > 1920 ? "15rem" : "15rem",
															}}
														>
															<label
																style={{ width: "100%", justifyContent: "center", display: "flex", gap: "1.5rem" }}
															>
																{file.name.length > 18
																	? `${file.name.slice(0, 14)}...${file.name.slice(file.name.lastIndexOf("."))}`
																	: file.name}
																<FaX
																	style={{ color: "red", cursor: "pointer" }}
																	onClick={() => {
																		files.set((prev) => prev?.filter((_, i) => i !== index) || null);
																	}}
																/>
															</label>
															{file.type === "application/pdf" ? (
																<FaRegFilePdf
																	style={{
																		fontSize:
																			window.innerHeight < 800 ? "27rem" : window.innerWidth > 1920 ? "27rem" : "27rem",
																	}}
																/>
															) : file.type.startsWith("image/") ? (
																<img
																	src={URL.createObjectURL(file)}
																	width={
																		window.innerHeight < 800 ? "270rem" : window.innerWidth > 1920 ? "270rem" : "270rem"
																	}
																	height={
																		window.innerHeight < 800 ? "270rem" : window.innerWidth > 1920 ? "270rem" : "270rem"
																	}
																	alt={`uploaded file ${index}`}
																	style={{ maxHeight: "100%", maxWidth: "100%" }}
																/>
															) : file.type.startsWith("video/") ? (
																<video
																	width={
																		window.innerHeight < 800 ? "200rem" : window.innerWidth > 1920 ? "270rem" : "270rem"
																	}
																	height={
																		window.innerHeight < 800 ? "200rem" : window.innerWidth > 1920 ? "270rem" : "270rem"
																	}
																	controls
																>
																	<source src={URL.createObjectURL(file)} type={file.type} />
																</video>
															) : (
																<FaRegFile
																	style={{
																		fontSize:
																			window.innerHeight < 800 ? "14rem" : window.innerWidth > 1920 ? "16rem" : "16rem",
																	}}
																/>
															)}
														</div>
													);
												})}
										</div>
										<Input
											{...defaultInput100}
											isTextArea
											placeholder="Mensagem automática"
											value={operatorRoutineMsg.value || ""}
											leftIcon={
												<>
													<label
														htmlFor="fileInput"
														style={{
															cursor: "pointer",
															width: "2.6rem",
															height: "1.5rem",
															display: "flex",
															alignItems: "center",
															alignContent: "center",
															justifyContent: "center",
														}}
													>
														<FaPaperclip />
													</label>
													<FaSmile
														color="yellow"
														style={{ cursor: "pointer" }}
														onClick={() => showEmojiPicker.set((prev) => !prev)}
													/>
												</>
											}
											onChange={(e) => {
												operatorRoutineMsg.set(e ? e.target.value : null);
											}}
										/>
									</div>
								</div>
							</>
						)}

						{showNewRoutineInputs === true && (
							<>
								<div style={{ display: "inline-block", gap: "1rem" }} className="time-select">
									<div style={{ display: "flex", gap: "1rem", flexDirection: "column" }}>
										<div style={{ display: "flex", gap: "1rem", width: "100%" }}>
											<div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
												<label>Horário de início</label>
												<Input
													{...defaultSelect100}
													type="time"
													value={newOperatorRoutine.value?.startTime || ""}
													onChange={(e) => {
														newOperatorRoutine.set((prev) => ({
															...prev,
															startTime: e ? e.target.value.toString() : undefined,
														}));
													}}
												/>
											</div>
											<div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
												<label>Horário de fim</label>
												<Input
													{...defaultSelect100}
													type="time"
													value={newOperatorRoutine.value?.endTime || ""}
													onChange={(e) => {
														newOperatorRoutine.set((prev) => ({
															...prev,
															endTime: e ? e.target.value.toString() : undefined,
														}));
													}}
												/>
											</div>
										</div>
									</div>
								</div>
								<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
									{showEmojiPicker.value && (
										<div
											style={{
												display: "flex",
												marginTop: `${window.innerHeight < 800 ? "0.8rem" : window.innerWidth > 1920 ? "3.5rem" : "4.5rem"
													}`,
												gap: "1rem",
												alignSelf: "center",
												maxHeight: "30rem",
												maxWidth: "100%",
												position: "absolute",
												zIndex: 9999,
												left: "6.2rem",
											}}
										>
											<EmojiPicker
												width="30rem"
												height={window.innerHeight < 800 ? "17rem" : window.innerWidth > 1920 ? "23rem" : "30rem"}
												previewConfig={{
													showPreview: false,
												}}
												onEmojiClick={(e) => operatorRoutineMsg.set((prev) => (prev ? prev + e.emoji : "" + e.emoji))}
											/>
										</div>
									)}

									<div
										style={{
											gap: "0",
											marginTop: `${window.innerHeight < 800 ? "18rem" : window.innerWidth > 1920 ? "27rem" : "35rem"}`,
										}}
									>
										<Input
											{...defaultInput100}
											$fontSize={0}
											$width="0px"
											$disableBorder
											style={{ display: "none" }}
											id="fileInput"
											type="file"
											accept="image/*,video/*,.pdf,.txt,.csv,.xlsx,.doc,.docx"
											onChange={(e) => {
												const uploadedFiles = e.target.files;
												if (uploadedFiles) {
													let totalSize = 0;
													let filesToAdd: File[] = [];
													for (let i = 0; i < uploadedFiles.length; i++) {
														totalSize += uploadedFiles[i].size;
														if (uploadedFiles[i].size > 50 * 1024 * 1024) {
															toast.error(`Arquivo ${uploadedFiles[i].name} é acima de 50MB.`);
															return;
														}
														if (totalSize > 50 * 1024 * 1024) {
															toast.error("O tamanho total dos arquivos é acima de 50MB.");
															return;
														}
														if (filesToAdd.length >= 5) {
															toast.error("Limite de 5 arquivos.");
															files.set(filesToAdd);
															return;
														}
														filesToAdd.push(uploadedFiles[i]);
													}
													if (totalSize > 50 * 1024 * 1024) {
														return;
													}
													files.set(filesToAdd);
												}
											}}
										/>
										<div
											style={{
												display: "flex",
												gap: "2rem",
												alignItems: "center",
												maxHeight: "0rem",
												maxWidth: "100%",
											}}
										>
											{files.value &&
												files.value.length > 0 &&
												files.value.map((file, index) => {
													return (
														<div
															key={index}
															style={{
																padding: "0.5rem",
																display: "flex",
																flexDirection: "column",
																alignItems: "center",
																justifyContent: "center",
																gap: "0.5rem",
																marginBottom:
																	window.innerHeight < 800 ? "17rem" : window.innerWidth > 1920 ? "20rem" : "21rem",
																maxHeight:
																	window.innerHeight < 800 ? "15rem" : window.innerWidth > 1920 ? "18rem" : "18rem",
																maxWidth:
																	window.innerHeight < 800 ? "15rem" : window.innerWidth > 1920 ? "15rem" : "15rem",
															}}
														>
															<label
																style={{ width: "100%", justifyContent: "center", display: "flex", gap: "1.5rem" }}
															>
																{file.name.length > 18
																	? `${file.name.slice(0, 14)}...${file.name.slice(file.name.lastIndexOf("."))}`
																	: file.name}
																<FaX
																	style={{ color: "red", cursor: "pointer" }}
																	onClick={() => {
																		files.set((prev) => prev?.filter((_, i) => i !== index) || null);
																	}}
																/>
															</label>
															{file.type === "application/pdf" ? (
																<FaRegFilePdf
																	style={{
																		fontSize:
																			window.innerHeight < 800 ? "27rem" : window.innerWidth > 1920 ? "27rem" : "27rem",
																	}}
																/>
															) : file.type.startsWith("image/") ? (
																<img
																	src={URL.createObjectURL(file)}
																	width={
																		window.innerHeight < 800 ? "270rem" : window.innerWidth > 1920 ? "270rem" : "270rem"
																	}
																	height={
																		window.innerHeight < 800 ? "270rem" : window.innerWidth > 1920 ? "270rem" : "270rem"
																	}
																	alt={`uploaded file ${index}`}
																	style={{ maxHeight: "100%", maxWidth: "100%" }}
																/>
															) : file.type.startsWith("video/") ? (
																<video
																	width={
																		window.innerHeight < 800 ? "200rem" : window.innerWidth > 1920 ? "270rem" : "270rem"
																	}
																	height={
																		window.innerHeight < 800 ? "200rem" : window.innerWidth > 1920 ? "270rem" : "270rem"
																	}
																	controls
																>
																	<source src={URL.createObjectURL(file)} type={file.type} />
																</video>
															) : (
																<FaRegFile
																	style={{
																		fontSize:
																			window.innerHeight < 800 ? "14rem" : window.innerWidth > 1920 ? "16rem" : "16rem",
																	}}
																/>
															)}
														</div>
													);
												})}
										</div>
										<Input
											{...defaultInput100}
											isTextArea
											placeholder="Mensagem automática"
											value={operatorRoutineMsg.value || ""}
											leftIcon={
												<>
													<label
														htmlFor="fileInput"
														style={{
															cursor: "pointer",
															width: "2.6rem",
															height: "1.5rem",
															display: "flex",
															alignItems: "center",
															alignContent: "center",
															justifyContent: "center",
														}}
													>
														<FaPaperclip />
													</label>
													<FaSmile
														color="yellow"
														style={{ cursor: "pointer" }}
														onClick={() => showEmojiPicker.set((prev) => !prev)}
													/>
												</>
											}
											onChange={(e) => {
												operatorRoutineMsg.set(e ? e.target.value : null);
											}}
										/>
									</div>
								</div>
							</>
						)}
						<div
							style={{
								display: "flex",
								flexDirection: "row",
								gap: "1rem",
								width: "100%",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							{showEditRoutineInputs === true && (
								<button
									style={{ padding: "0.625rem 2rem", fontSize: "1rem", marginTop: "1rem", alignSelf: "center" }}
									onClick={() => deleteRoutineFn()}
								>
									Excluir rotina
								</button>
							)}
							<button
								className={disabled ? "disabled" : ""}
								onClick={(e) => {
									if (disabled) {
										e.preventDefault();
										toast.error("Preencha todos os campos corretamente");
									}
									if (createNewRoutine.value) {
										createNewRoutineFn();
									}
									if (editRoutine.value) {
										updateRoutineFn();
									}
								}}
								style={{ padding: "0.625rem 2rem", fontSize: "1rem", marginTop: "1rem", alignSelf: "center" }}
							>
								{createNewRoutine.value ? "Criar rotina" : "Atualizar rotina"}
							</button>
						</div>
					</>
				)}
			</div>
		</StyledCreateAutomaticMsgRoutinePage>
	);
};
